import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '~/lib/utils'

// 빈 상태 안내 — 아이콘 + 제목 + 설명 + (선택) 액션. 미니멀 톤, 시맨틱 토큰만.
export interface EmptyStateProps {
    icon?: LucideIcon
    title: string
    description?: ReactNode
    /** 선택 액션(버튼 등). 보통 <Button>을 넘긴다. */
    action?: ReactNode
    className?: string
}

/** 데이터/검색 결과가 없을 때 표시하는 안내 블록. */
export function EmptyState({
    icon: Icon,
    title,
    description,
    action,
    className,
}: EmptyStateProps) {
    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center gap-2 px-6 py-12 text-center',
                className
            )}>
            {Icon ? (
                <span className='bg-secondary text-muted-foreground mb-1 flex size-10 items-center justify-center rounded-full'>
                    <Icon className='size-5' />
                </span>
            ) : null}
            <p className='text-foreground text-[13px] font-medium'>{title}</p>
            {description ? (
                <p className='text-muted-foreground max-w-sm text-[13px]'>
                    {description}
                </p>
            ) : null}
            {action ? <div className='mt-2'>{action}</div> : null}
        </div>
    )
}
